/**
 * 处理真实价格
 * 1. 如果存在多个小数点，只留下最后一个小数点，删除之前的所有小数点
 * 2. 小数点后永远保留两位小数，超出部分四舍五入
 * 3. 删除所有非数字小数点的内容
 * 4. 如果一个数字都没有，返回""
 */
export function parseRealPrice(input: string): string {
  // 删除所有非数字和小数点的字符
  let cleaned = input.replace(/[^\d.]/g, "")

  // 如果清理后没有数字，返回空字符串
  if (!cleaned || cleaned === ".") {
    return ""
  }

  // 找到最后一个小数点的位置
  const lastDotIndex = cleaned.lastIndexOf(".")
  if (lastDotIndex !== -1) {
    // 将最后一个小数点之前的所有小数点删除
    const beforeLastDot = cleaned.slice(0, lastDotIndex).replace(/\./g, "")
    const afterLastDot = cleaned.slice(lastDotIndex + 1)
    cleaned = beforeLastDot + "." + afterLastDot
  }

  // 转换为数字并保留两位小数
  const number = parseFloat(cleaned || "0")
  return `${Math.round(number * 100) / 100}`
}

/**
 * 格式化显示价格
 * 1. 先获取到真实价格
 * 2. 如果真实价格超过一千，为价格添加千分位符号
 * 3. 保留两位小数
 */
export function formatDisplayPrice(price: number): string {
  // return price.toLocaleString("en-US", {
  //   minimumFractionDigits: 2,
  //   maximumFractionDigits: 2,
  // })
  if (!price) return ""
  return Number(price)?.toFixed(2)
}
